import React from 'react';
import './style.css';

interface AppRippleProps {
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
}

const AppRipple: React.FC<AppRippleProps> = ({ onClick }) => {
  const handleClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    const span = event.currentTarget;
    const rect = span.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;
    
    // Create ripple element
    const ripple = document.createElement('span');
    ripple.className = 'app-ripple-effect';
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = x + 'px';
    ripple.style.top = y + 'px';
    
    // Add to parent
    span.appendChild(ripple);
    
    // Remove after animation
    setTimeout(() => {
      if (ripple.parentNode) {
        ripple.parentNode.removeChild(ripple);
      }
    }, 600);
    
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <span 
      className="app-ripple-container" 
      onClick={handleClick}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }}
    />
  );
};

export default AppRipple;
